
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/food-program",
      function () {
        return require("private-next-pages/food-program.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/food-program"])
      });
    }
  